import http from "../http-common";

class UsuarioService {

    get(id) {
        return http.get(`/usuario/${id}`);
    }

    getAll() {
        return http.get('/usuario');
    }

    delete(id) {
        return http.delete(`/usuario/${id}`);
    }

    update(id) {
        return http.put(`/usuario/${id}`)
    }

    create(data) {
        return http.post("/usuario", data);
    }

    ingresar(data) {
        return http.post("/usuario/ingreso", data);
    }

    getByMail(data) {
        return http.post("/usuario/correo", data);
    }
}

export default new UsuarioService();